"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Remove_exports = {};
__export(Remove_exports, {
  default: () => Remove_default
});
module.exports = __toCommonJS(Remove_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.2617 3.02344L2.76562 11.5195C2.63542 11.6497 2.57031 11.806 2.57031 11.9883C2.57031 12.1706 2.63542 12.3268 2.76562 12.457L7.86328 17.4766C7.88932 17.4896 7.90885 17.5091 7.92188 17.5352C7.94792 17.5482 7.97396 17.5612 8 17.5742C8.03906 17.6003 8.08464 17.6263 8.13672 17.6523C8.1888 17.6654 8.24089 17.6719 8.29297 17.6719H17.9023C18.0326 17.6719 18.1432 17.6263 18.2344 17.5352C18.3385 17.431 18.3906 17.3073 18.3906 17.1641C18.3906 17.0339 18.3385 16.9232 18.2344 16.832C18.1432 16.7279 18.0326 16.6758 17.9023 16.6758H11.457L18.2344 9.97656C18.3646 9.84635 18.4297 9.6901 18.4297 9.50781C18.4297 9.32552 18.3646 9.16927 18.2344 9.03906L12.2188 3.02344C12.0885 2.89323 11.9258 2.82812 11.7305 2.82812C11.5482 2.82812 11.3919 2.89323 11.2617 3.02344ZM11.7305 3.96094L17.2969 9.50781L15.4219 11.3633L9.875 5.81641L11.7305 3.96094ZM3.70312 11.9883L9.17188 6.53906L14.6992 12.0664L10.0508 16.6758H8.46875L3.70312 11.9883Z",
      fill: "currentColor"
    }
  )
);
const SvgRemove = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Remove_default = SvgRemove;
